export default __webpack_public_path__ + "static/media/icon-chevron-stop-left.1e4742bd.svg";